import { useState, useEffect } from 'react';
import {Dialog, DialogTitle, DialogContent, Box, IconButton, TextField, Select, MenuItem, FormControl, Typography} from '@mui/material';
import { Add, Check, Close } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import { courseService } from '../../services/api';
import { Close as CloseIcon } from '@mui/icons-material';
const ContentSelectionModal = ({
    open,
    onClose,
    courseId,
    audienceType,
    onSelect,
    selectedContents
    }) => {    
        const [subtypeFilters, setSubtypeFilters] = useState([]);
        const [components, setComponents] = useState([]);
        const [page, setPage] = useState(0);
        const [pageSize, setPageSize] = useState(10);
        const [totalRows, setTotalRows] = useState(0);
        const [loading, setLoading] = useState(false);
        const [filters, setFilters] = useState({
            search: '',
            subType: '',
            type: ''
        });

    // Add this style in your component
    const dialogContentStyle = {
        '&::-webkit-scrollbar': {
            width: '6px'
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1'
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '4px'
        }
    };    
    const isContentSelected = (contentId) => {
        // contentId format is typically "id|type"
        const [id, type] = contentId.split('|');
        
        return selectedContents.some(content => {
            // Split the selected content's cust_id
            const [selectedId, selectedType] = content.cust_id.split('|');
            
            // Check if both ID and type match
            return selectedId === id && selectedType === type;
        });
    };

    useEffect(() => {
        if (open) {
          loadComponents();
        }
    }, [open, filters, audienceType]);

    // const typeOptions = ['content', 'quiz', 'assignment'];
    const typeOptions = ['Content'];
    const loadComponents = async (newPage = page, newPageSize = pageSize) => {
        setLoading(true);
        try {
            const response = await courseService.getComponentsList({
                ...filters,
                courseId,
                audienceType,
                start: newPage * newPageSize,
                length: newPageSize,
                draw: 1
            });
          
            setComponents(response.data.aaData);
            setTotalRows(response.data.recordsTotal);
            setSubtypeFilters(response.data.subtypeFilters);
        } catch (error) {
            console.error('Error loading components:', error);
        } finally {
            setLoading(false);
        }
    }

    const columns = [
        { 
          field: '1',
          headerName: 'Component Name',
          flex: 1,
          // A long name ends with '...' instead of being cut off (N14 pt 5.1).
          renderCell: (params) => (
            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} dangerouslySetInnerHTML={{ __html: params.value }} />
          )
        },
        { field: '2', headerName: 'Subtype', width: 150 },
        { field: '3', headerName: 'Type', width: 150 },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 100,
            renderCell: (params) => {
              const isSelected = isContentSelected(params.row[0]);
              return (
                <IconButton
                  color={isSelected ? "success" : "primary"}
                  onClick={() => onSelect(params.row)}
                  disabled={isSelected}
                >
                  {isSelected ? <Check /> : <Add />}
                </IconButton>
              );
            }
        }
    ];

    const handleFilterChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
        setPage(0);
    };
    
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Select Course Content</Typography>
                    <IconButton onClick={onClose} size="small"><Close /></IconButton>
                </Box>
            </DialogTitle>
            <DialogContent sx={dialogContentStyle}>
                <Box sx={{ display: 'flex', gap: 2, mb: 3, mt: 1 }}>
                    <TextField
                        size="small"
                        label="Search"
                        value={filters.search}
                        onChange={(e) => handleFilterChange('search', e.target.value)}
                        sx={{ minWidth: 200 }}
                        placeholder="Search"
                    />
                    <FormControl 
                        fullWidth 
                        margin="normal"
                        sx={{ mb: 2 }}
                        variant="outlined"
                    >
                        <Select
                            size="small"
                            value={filters.subType}
                            onChange={(e) => handleFilterChange('subType', e.target.value)}
                            displayEmpty
                            
                        >
                            <MenuItem value=""  size="small">All Subtypes</MenuItem>
                            {subtypeFilters.map(subtype => (
                                <MenuItem key={subtype} value={subtype}>{subtype}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl 
                        fullWidth 
                        margin="normal"
                        sx={{ mb: 2 }}
                        variant="outlined"
                    >
                        <Select
                            size="small"
                            value={filters.type}
                            onChange={(e) => handleFilterChange('type', e.target.value)}
                            displayEmpty
                            
                        >
                            <MenuItem value=""  size="small">All Types</MenuItem>
                            {typeOptions.map(type => (
                            <MenuItem key={type} value={type}>{type}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>

                <DataGrid
                    rows={components}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: 10, page: 0 },
                        },
                    }}
                    pageSizeOptions={[10, 25, 50]}
                    pagination
                    paginationMode="server"
                    rowCount={totalRows}
                    loading={loading}
                    getRowId={(row) => row[0]}
                    onPaginationModelChange={(newModel) => {
                        setPage(newModel.page);
                        setPageSize(newModel.pageSize);
                        loadComponents(newModel.page, newModel.pageSize);
                    }}
                    //sx={{ height: 400 }}
                />
            </DialogContent>            
        </Dialog>
    );
};

export default ContentSelectionModal;